module.exports = __webpack_public_path__ + "static/media/logobantuan-clean.b88c8fa2.png";